//import { v4 } from "uuid";
import { type TrackingInformation } from "../../../../utilities/product-link-tracking";
import { type ProductRegistrationResult } from "./list-item-component/common/product-updater";
import { type Segment } from "./segment";

export interface GenericItemBase<TypeString extends string> {
    type: TypeString;
}

export interface ListItem<TypeString extends string>
    extends GenericItemBase<TypeString> {
    identifier: string;
    uniqueidentifier: string;
    page: number;
    firstOfPage: boolean;
}

export type ListItemImplementation =
    | ProductListItem
    | AdvertItem
    | FillerItem
    | ProductGalleryItem;

export interface SpecialConfigurations {
    disableFreight: boolean;
    optionalAuctionSetting: number;
    certificateImplementation: number;
    disableStockLimitations: boolean;
}

export interface ProductInformation extends IProductPictureInfo {
    productName: string;
    productId: number;
    link: string;
    pictureAltText: any;
    productTypeInt: any;
    priceComparisonEnabled: any;
    contextAuctionId: any;
    typeHasAuction: any;
    typeHasBuyNow: any;
    hideEstimatedValue: any;
    productEstimatedValue: any;
    buyNowPrice: any;
    hasBid: any;
    currentBid: number;
    experienceOverlayText: any;
    showThirdPartyStamp: any;
    specialConfigurations: SpecialConfigurations;
    showTimeCounter: any;
    timeIsNotStarted: any;
    timeTotalSeconds: number;
    auctionName: any;
    productIsActive: any;
    timeIsActive: any;
    stockStatusText: any;
    stockStatusIconCssClass: any;
    showRegionInfo: any;
    hasFreightMethods: any;
    hasMultipleFreightMethods: any;
    freightPrice: any;
    deliveryPrice: any;
    deliveryContact: any;
    hasPickupData: any;
    pickupHint: any;
    hasRegionData: any;
    regionText: any;
    hasExperienceInfo: any;
    experienceText: any;
    actionButtonText: any;
    deliverySpecify: boolean;
    actionMode?: string;
    actionHref?: string;
    hideAuctionField?: boolean;
}

export interface FillerItem extends ListItem<"filler"> {
    filler: true;
    visible: boolean;
    registration: undefined;
    width: number | undefined;
    height: number | undefined;
}

export interface IProductPictureInfo {
    pictureUrl: string | undefined | null;
    pictureWidth: number | undefined | null;
    pictureHeight: number | undefined | null;
    pictureUrlAsWebp: string | undefined | null;
    pictureSrcSet: string | undefined | null;
    pictureSrcSetAsWebp: string | undefined | null;
}

export interface IProductSecondsCountdown {
    timeTotalSeconds: number;
    timeIsNotStarted: boolean;
}

export interface ProductListCachedProductViewModel
    extends ProductListCachedProduct {
    registration?: ProductRegistrationResult | undefined;
}

export interface ProductListCachedProduct
    extends IProductPictureInfo,
        IProductSecondsCountdown {
    productId: number;
    productName: string;
    isAuction: boolean;
    isShop: boolean;
    isBuyNow: boolean;

    price: number;
    hasBid: boolean;
    value: number | undefined | null;

    timeTotalSeconds: number;
    timeIsNotStarted: boolean;
    link: string;

    overlayText: string | undefined | null;
    overlayTextType: string | undefined | null;
    thirdPartyStamp: boolean;
    relatedAuctionStamp: boolean;
    relatedShopStamp: boolean;

    overwriteAction?: boolean;
    actionButtonText?: string | undefined | null;
    actionHref?: string | undefined | null;
    actionMode?: string | undefined | null;
    trackingInfo?: TrackingInformation | undefined | null;
}

let counter = 0;

export class ProductListItem
    implements ListItem<"product">, ProductListCachedProduct
{
    registration: ProductRegistrationResult | undefined;
    trackingInfo: TrackingInformation | undefined | null;
    constructor(
        data: ProductListCachedProduct,
        firstOfPage: boolean,
        trackingInfo: TrackingInformation | undefined | null,
        page: number
    ) {
        this.type = "product";
        this.identifier = "product-" + data.productId;
        this.page = page;
        this.firstOfPage = firstOfPage;
        //this.uniqueidentifier = v4();
        this.uniqueidentifier = "el_" + counter++;
        this.trackingInfo = trackingInfo;
        this.productId = data.productId;
        this.isAuction = data.isAuction;
        this.isShop = data.isShop;
        this.isBuyNow = data.isBuyNow;
        this.timeTotalSeconds = data.timeTotalSeconds;
        this.timeIsNotStarted = data.timeIsNotStarted;
        this.link = data.link;
        this.overlayText = data.overlayText;
        this.overlayTextType = data.overlayTextType;
        this.thirdPartyStamp = data.thirdPartyStamp;
        this.relatedAuctionStamp = data.relatedAuctionStamp;
        this.relatedShopStamp = data.relatedShopStamp;
        this.pictureUrl = data.pictureUrl;
        this.pictureWidth = data.pictureWidth;
        this.pictureHeight = data.pictureHeight;
        this.pictureUrlAsWebp = data.pictureUrlAsWebp;
        this.pictureSrcSet = data.pictureSrcSet;
        this.pictureSrcSetAsWebp = data.pictureSrcSetAsWebp;
        this.timeTotalSeconds = data.timeTotalSeconds;
        this.timeIsNotStarted = data.timeIsNotStarted;
        this.productName = data.productName;
        this.price = data.price;
        this.hasBid = data.hasBid;
        this.value = data.value ?? undefined;
    }
    identifier: string;
    uniqueidentifier: string;
    page: number;
    firstOfPage: boolean;
    type: "product";
    productId: number;
    productName: string;
    price: number;
    hasBid: boolean;
    value: number | undefined;
    isAuction: boolean;
    isShop: boolean;
    isBuyNow: boolean;
    timeTotalSeconds: number;
    timeIsNotStarted: boolean;
    link: string;
    overlayText: string | null | undefined;
    overlayTextType: string | null | undefined;
    overlayTextLink: string | null | undefined;
    thirdPartyStamp: boolean;
    relatedAuctionStamp: boolean;
    relatedShopStamp: boolean;
    pictureUrl: string | null | undefined;
    pictureWidth: number | null | undefined;
    pictureHeight: number | null | undefined;
    pictureUrlAsWebp: string | null | undefined;
    pictureSrcSet: string | null | undefined;
    pictureSrcSetAsWebp: string | null | undefined;
}

// export class ProductListItem
//     implements ListItem<"product">, ProductInformation, IProductPictureInfo
// {
//     productName: any;
//     productId: any;
//     link: any;
//     pictureUrl: string | undefined | null;
//     pictureWidth: number | undefined | null;
//     pictureHeight: number | undefined | null;
//     pictureUrlAsWebp: string | undefined | null;
//     pictureSrcSet: string | undefined | null;
//     pictureSrcSetAsWebp: string | undefined | null;
//     productTypeInt: any;
//     priceComparisonEnabled: any;
//     contextAuctionId: any;
//     typeHasAuction: any;
//     typeHasBuyNow: any;
//     hideEstimatedValue: any;
//     productEstimatedValue: any;
//     buyNowPrice: any;
//     hasBid: any;
//     currentBid!: number;
//     experienceOverlayText: any;
//     showThirdPartyStamp: any;
//     specialConfigurations!: SpecialConfigurations;
//     showTimeCounter: any;
//     timeIsNotStarted: any;
//     timeTotalSeconds: number = 0;
//     auctionName: any;
//     productIsActive: any;
//     timeIsActive: any;
//     stockStatusText: any;
//     stockStatusIconCssClass: any;
//     showRegionInfo: any;
//     hasFreightMethods: any;
//     hasMultipleFreightMethods: any;
//     freightPrice: any;
//     deliveryPrice: any;
//     deliveryContact: any;
//     hasPickupData: any;
//     pickupHint: any;
//     hasRegionData: any;
//     regionText: any;
//     hasExperienceInfo: any;
//     experienceText: any;
//     actionButtonText: any;
//     trackingInfo: any;
//     deliverySpecify: boolean = false;
//     constructor(
//         data: ProductInformation,
//         firstOfPage: boolean,
//         trackingInfo: TrackingInformation,
//         page: number
//     ) {
//         this.type = "product";
//         this.identifier = "product-" + data.productId;
//         this.page = page;
//         this.firstOfPage = firstOfPage;
//         this.uniqueidentifier = v4();
//         this.updateFromInformation(data, trackingInfo);
//     }
//     identifier: string;
//     uniqueidentifier: string;
//     page: number;
//     firstOfPage: boolean;
//     type: "product";
//     actionMode?: string | undefined;
//     actionHref?: string | undefined;
//     hideAuctionField?: boolean | undefined;

//     pictureAltText: any;
//     updateFromInformation(
//         data: ProductInformation,
//         trackingInfo: TrackingInformation
//     ) {
//         this.productName = data.productName;
//         this.productId = data.productId;
//         this.link = data.link;
//         this.pictureUrl = data.pictureUrl;
//         this.pictureWidth = data.pictureWidth;
//         this.pictureHeight = data.pictureHeight;
//         this.pictureUrlAsWebp = data.pictureUrlAsWebp;
//         this.pictureSrcSet = data.pictureSrcSet;
//         this.pictureSrcSetAsWebp = data.pictureSrcSetAsWebp;
//         this.pictureAltText = data.pictureAltText;
//         this.productTypeInt = data.productTypeInt;
//         this.priceComparisonEnabled = data.priceComparisonEnabled;
//         this.contextAuctionId = data.contextAuctionId;
//         this.typeHasAuction = data.typeHasAuction;
//         this.typeHasBuyNow = data.typeHasBuyNow;
//         this.hideEstimatedValue = data.hideEstimatedValue;
//         this.productEstimatedValue = data.productEstimatedValue;
//         this.buyNowPrice = data.buyNowPrice;
//         this.hasBid = data.hasBid;
//         this.currentBid = data.currentBid;
//         this.experienceOverlayText = data.experienceOverlayText;
//         this.showThirdPartyStamp = data.showThirdPartyStamp;
//         this.specialConfigurations = data.specialConfigurations;
//         this.showTimeCounter = data.showTimeCounter;
//         this.timeIsNotStarted = data.timeIsNotStarted;
//         this.timeTotalSeconds = data.timeTotalSeconds;
//         this.auctionName = data.auctionName;
//         this.productIsActive = data.productIsActive;
//         this.timeIsActive = data.timeIsActive;
//         this.stockStatusText = data.stockStatusText;
//         this.stockStatusIconCssClass = data.stockStatusIconCssClass;
//         this.showRegionInfo = data.showRegionInfo;
//         this.hasFreightMethods = data.hasFreightMethods;
//         this.hasMultipleFreightMethods = data.hasMultipleFreightMethods;
//         this.freightPrice = data.freightPrice;
//         this.deliveryPrice = data.deliveryPrice;
//         this.deliveryContact = data.deliveryContact;
//         this.hasPickupData = data.hasPickupData;
//         this.pickupHint = data.pickupHint;
//         this.hasRegionData = data.hasRegionData;
//         this.regionText = data.regionText;
//         this.hasExperienceInfo = data.hasExperienceInfo;
//         this.experienceText = data.experienceText;
//         this.actionButtonText = data.actionButtonText;
//         this.trackingInfo = trackingInfo;
//         this.deliverySpecify = data.deliverySpecify;
//     }
// }

export interface IAdvertItem {
    itemId: number;
    link: string;
    mobileImage: string;
    mobileImageSrcSet: string;
    mobileImageSrcSetAsWebp: string;
    mobileImageWidth: number;
    mobileImageHeight: number;
    desktopImage: string;
    desktopImageSrcSet: string;
    desktopImageSrcSetAsWebp: string;
    desktopImageWidth: number;
    desktopImageHeight: number;
    page: number;
    advertCounter: number;
    pinToTop: boolean;
}

export class ProductGalleryItem implements ListItem<"gallery"> {
    registration: ProductRegistrationResult | undefined;
    identifier: string;
    uniqueidentifier: string;
    page: number;
    firstOfPage: boolean;
    segment: Segment;
    type: "gallery";
    constructor(segment: Segment, page: number, firstOfPage: boolean) {
        this.identifier = "gallery-" + segment.identifier;
        this.uniqueidentifier = "el_" + counter++;
        this.page = page;
        this.firstOfPage = firstOfPage;
        this.type = "gallery";
        this.segment = segment;
    }
}

export class AdvertItem implements ListItem<"advert">, IAdvertItem {
    itemId: number;
    pinToTop: boolean;
    registration: undefined;
    advertId: number;
    link: string;
    mobileImage: string;
    mobileImageSrcSet: string;
    mobileImageSrcSetAsWebp: string;
    mobileImageWidth: number;
    mobileImageHeight: number;
    desktopImage: string;
    desktopImageSrcSet: string;
    desktopImageSrcSetAsWebp: string;
    desktopImageWidth: number;
    desktopImageHeight: number;
    advertCounter: number;
    identifier: string;
    uniqueidentifier: string;
    page: number;
    firstOfPage: boolean;
    type: "advert";
    constructor(
        {
            itemId,
            link,
            mobileImage,
            mobileImageSrcSet,
            mobileImageSrcSetAsWebp,
            mobileImageWidth,
            mobileImageHeight,
            desktopImage,
            desktopImageSrcSet,
            desktopImageSrcSetAsWebp,
            desktopImageWidth,
            desktopImageHeight,
            page,
            advertCounter,
            pinToTop,
        }: IAdvertItem,
        firstOfPage: boolean
    ) {
        this.identifier = "advert-" + itemId + "-instance-" + advertCounter;
        this.type = "advert";
        this.page = page;
        this.firstOfPage = firstOfPage;
        //this.uniqueidentifier = v4();
        this.uniqueidentifier = "el_" + counter++;
        this.advertId = itemId;
        this.link = link;
        this.mobileImage = mobileImage;
        this.mobileImageSrcSet = mobileImageSrcSet;
        this.mobileImageSrcSetAsWebp = mobileImageSrcSetAsWebp;
        this.mobileImageWidth = mobileImageWidth;
        this.mobileImageHeight = mobileImageHeight;
        this.desktopImage = desktopImage;
        this.desktopImageSrcSet = desktopImageSrcSet;
        this.desktopImageSrcSetAsWebp = desktopImageSrcSetAsWebp;
        this.desktopImageWidth = desktopImageWidth;
        this.desktopImageHeight = desktopImageHeight;
        this.advertCounter = advertCounter;
        this.itemId = itemId;
        this.pinToTop = pinToTop;
    }
}
